// extracted by mini-css-extract-plugin
module.exports = {"container":"platform-header_container__cSO5f","header":"platform-header_header___Y_VH","copy":"platform-header_copy__LNEPE","subheader":"platform-header_subheader__ydOpW"};